export type Tab = "rank" | "pillars";

const TABS: { key: Tab; label: string }[] = [
  { key: "rank", label: "Rank" },
  { key: "pillars", label: "Pillars" },
];

/**
 * The one header both tabs share. The tabs are separate products, not two settings
 * of one view: Rank serves a recipe that ships with its measured record; Pillars is
 * a workbench whose weights carry no record until they are backtested.
 */
export function TopBar({
  user,
  onLogout,
  tab,
  onTab,
}: {
  user: string;
  onLogout: () => void;
  tab: Tab;
  onTab: (t: Tab) => void;
}) {
  return (
    <header className="h-9 shrink-0 flex items-center gap-3 px-3 border-b border-term-edge bg-term-panel">
      <span className="text-term-accent">srank</span>
      <nav className="flex h-full items-stretch text-[11px]">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => onTab(t.key)}
            className={`px-3 border-b-2 ${
              tab === t.key
                ? "border-term-accent text-term-text"
                : "border-transparent text-term-dim hover:text-term-text"
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>
      <div className="flex-1" />
      <span className="text-term-dim text-[11px]">{user}</span>
      <button onClick={onLogout} className="text-term-dim hover:text-term-text text-[11px]">
        sign out
      </button>
    </header>
  );
}
